import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import GoogleLoginButton from "./GoogleAuthButton";
import { auth, signOut } from "../firebase"; 

export default function MobileHistoryPanel(props) {
  const navigate = useNavigate();
  const {
    showHistoryMobile,
    sessions,
    currentSessionId,
    confirmingDelete,
    setConfirmingDelete,
    setShowHistoryMobile,
    openSession,
    deleteSession,
    groupSessionsByDate,
    lastUserQuestionSafe,
    getSubjectIcon,
    showSocialMenu,
    setShowSocialMenu,
    socialMenuRef,
    setShowFeedback,
    newSessions,
    openDeleteAllModal,
    showDeleteAllModal,
    confirmDeleteAll,
    closeDeleteAllModal,
    DangerModal,
    leftFooterStyle,
    currentUser,
    setShowProfileEditModal,
    setProfileSubTab,
    setActiveTab // Example prop if you manage tabs via parent state
  } = props;

  // State to manage the temporary highlight & toast alert after login
  const [showProfileAlert, setShowProfileAlert] = useState(false);

  useEffect(() => {
    if (currentUser) {
      setShowProfileAlert(true);
      const timer = setTimeout(() => {
        setShowProfileAlert(false);
      }, 5000); // Alert displays and highlights for 5 seconds
      return () => clearTimeout(timer);
    }
  }, [currentUser]);

  // Handler to open the battle tab / view safely
  // Handler to open the battle tab / view safely within user profile
  const handleOpenBattleTab = () => {
    // Close the mobile history sidebar first
    setShowHistoryMobile(false);
    if (setConfirmingDelete) setConfirmingDelete(null);

    // If you pass down tab setters from UserProfilePanel, call them directly:
    if (typeof setActiveTab === "function") {
      setActiveTab("profile");
    }
    if (typeof setProfileSubTab === "function") {
      setProfileSubTab("battles");
    } else {
      // Fallback if route-based navigation is preferred outside the profile panel
      navigate("/profile"); 
    }
  };

  if (!showHistoryMobile) return null;

  return (
    <div 
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(15, 23, 42, 0.5)",
        backdropFilter: "blur(4px)",
        zIndex: 9998,
        display: "flex",
        justifyContent: "flex-start",
        animation: "fadeIn 0.2s ease-out"
      }}
      onClick={() => {
        setShowHistoryMobile(false);
        setConfirmingDelete(null);
      }}
    >
      <div 
        className="mobile-sidebar-container"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "85%",
          maxWidth: "340px",
          height: "100%",
          backgroundColor: "#f8fafc",
          display: "flex",
          flexDirection: "column",
          boxShadow: "4px 0 25px rgba(0, 0, 0, 0.15)",
          animation: "slideInLeft 0.25s cubic-bezier(0.16, 1, 0.3, 1)"
        }}
      >
        {/* --- 1. Top Bar --- */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px", backgroundColor: "#ffffff", borderBottom: "1px solid #e2e8f0" }}>
           <Link 
             to="/" 
             onClick={() => {
               setShowHistoryMobile(false);
               if (setConfirmingDelete) setConfirmingDelete(null);
             }}
             style={{ fontWeight: "800", fontSize: "1.1rem", display: "flex", alignItems: "center", gap: "8px", textDecoration: "none", cursor: "pointer" }}
           >
             <img 
               src="/logo.png" 
               alt="Agni Tutor logo" 
               className="brand-logo-img" 
               style={{ width: "28px", height: "28px", objectFit: "contain", borderRadius: "6px" }} 
             />
             <span>
               <span style={{ color: "#f97316" }}>Agni</span>{" "}
               <span style={{ color: "#0f172a" }}>Tutor</span>
             </span>
           </Link>

           <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
             <button
                className="icon-action-btn primary-glow"
                onClick={() => {
                  if (typeof newSessions === "function") {
                    newSessions();
                  }

                  setShowHistoryMobile(false);
                  setConfirmingDelete(null);

                  navigate("/"); // Go to index page
                }}
                title="New Chat"
              >
                <span className="material-icons">add_circle</span>
              </button>

             <button
               onClick={() => {
                 setShowHistoryMobile(false);
                 setConfirmingDelete(null);
               }}
               style={{
                 background: "#f1f5f9",
                 border: "none",
                 borderRadius: "50%",
                 width: "32px",
                 height: "32px",
                 display: "flex",
                 alignItems: "center",
                 justifyContent: "center",
                 cursor: "pointer",
                 color: "#475569",
                 marginLeft: "2px"
               }}
             >
               <span className="material-icons" style={{ fontSize: "18px" }}>close</span>
             </button>
          </div>
        </div> 

        <div 
            className="slim-orange-scrollbar"
            style={{ 
                flex: 1, 
                minHeight: 0, 
                overflowY: "auto", 
                display: "flex", 
                flexDirection: "column", 
                paddingBottom: "24px" 
            }}
        >
          
          {/* --- Toast Alert Notification Banner --- */}
          {showProfileAlert && (
            <div style={{
              margin: "12px 16px 0 16px",
              padding: "10px 12px",
              backgroundColor: "#e0e7ff",
              border: "1px solid #c7d2fe",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              animation: "fadeIn 0.3s ease-in-out"
            }}>
              <span className="material-icons" style={{ fontSize: "20px", color: "#4f46e5" }}>info</span>
              <div style={{ fontSize: "0.8rem", color: "#312e81", fontWeight: "500", lineHeight: "1.3" }}>
                <strong>Profile Edit Enabled!</strong> You can now update your account settings below.
              </div>
            </div>
          )}

          {/* --- 2. User Profile Section --- */}
          <div style={{ backgroundColor: "#ffffff", padding: "16px", borderBottom: "1px solid #e2e8f0" }}>
            {currentUser ? (
              <div>
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  {currentUser.photoURL ? (
                    <img 
                      src={currentUser.photoURL} 
                      alt="Profile" 
                      referrerPolicy="no-referrer"
                      style={{ width: "48px", height: "48px", borderRadius: "50%", objectFit: "cover" }} 
                      onError={(e) => {
                        // Fallback image if the profile photo fails to load
                        e.target.src = "https://ui-avatars.com/api/?name=" + encodeURIComponent(currentUser.displayName || "User") + "&background=0f172a&color=fff";
                      }}
                    />
                  ) : (
                    <div style={{ 
                      width: "48px", 
                      height: "48px", 
                      borderRadius: "50%", 
                      background: "linear-gradient(135deg, #fb923c 0%, #ea580c 100%)",
                      display: "flex", 
                      alignItems: "center", 
                      justifyContent: "center",
                      color: "white",
                      fontSize: "1.2rem",
                      fontWeight: "bold",
                      boxShadow: "0 4px 10px rgba(234, 88, 12, 0.2)"
                    }}>
                      {currentUser.displayName ? currentUser.displayName.charAt(0).toUpperCase() : "S"}
                    </div>
                  )}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: "1rem", fontWeight: "700", color: "#0f172a", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {currentUser.displayName || "Student"}
                    </div>
                    <div style={{ fontSize: "0.8rem", color: "#64748b", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {currentUser.email || ""}
                    </div>
                  </div>
                  <button
                    onClick={async () => {
                      try {
                        await signOut(auth);
                        localStorage.removeItem("currentUser");
                        window.location.href = "/";
                      } catch (error) {
                        console.error("Logout Error:", error);
                      }
                    }}
                    style={{
                      padding: "6px 10px",
                      backgroundColor: "#fee2e2",
                      color: "#dc2626",
                      border: "none",
                      borderRadius: "8px",
                      fontSize: "0.75rem",
                      fontWeight: "600",
                      cursor: "pointer"
                    }}
                  >
                    Logout
                  </button>
                </div>
              </div>
            ) : (
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <div style={{ 
                  width: "48px", 
                  height: "48px", 
                  borderRadius: "50%", 
                  background: "linear-gradient(135deg, #cbd5e1 0%, #94a3b8 100%)",
                  display: "flex", 
                  alignItems: "center", 
                  justifyContent: "center",
                  color: "white",
                  fontSize: "1.2rem",
                  fontWeight: "bold"
                }}>
                  S
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: "600", color: "#1e293b", fontSize: "0.95rem" }}>Guest Student</div>
                  <div style={{ fontSize: "0.75rem", color: "#64748b", marginBottom: "8px" }}>Sign in to save progress</div>
                  
                  <GoogleLoginButton />
                </div>
              </div>
            )}

            {/* Gamification/Stats Grid */}
            <div style={{ display: "flex", gap: "10px", marginTop: "16px" }}>
              <div style={{ flex: 1, backgroundColor: "#fff7ed", border: "1px solid #ffedd5", borderRadius: "10px", padding: "10px", display: "flex", alignItems: "center", gap: "8px" }}>
                <span style={{ fontSize: "20px" }}>🔥</span>
                <div>
                  <div style={{ fontSize: "0.7rem", fontWeight: "600", color: "#c2410c", textTransform: "uppercase" }}>Streak</div>
                  <div style={{ fontSize: "1rem", fontWeight: "700", color: "#9a3412" }}>3 Days</div>
                </div>
              </div>
              <div style={{ flex: 1, backgroundColor: "#fefce8", border: "1px solid #fef08a", borderRadius: "10px", padding: "10px", display: "flex", alignItems: "center", gap: "8px" }}>
                <span style={{ fontSize: "20px" }}>⭐</span>
                <div>
                  <div style={{ fontSize: "0.7rem", fontWeight: "600", color: "#a16207", textTransform: "uppercase" }}>Points</div>
                  <div style={{ fontSize: "1rem", fontWeight: "700", color: "#854d0e" }}>1,250</div>
                </div>
              </div>
            </div>
          </div>

          {/* --- 3. Navigation / Features Menu --- */}
          <div style={{ padding: "16px", display: "flex", flexDirection: "column", gap: "8px" }}>
            <div style={{ fontSize: "0.75rem", fontWeight: "700", color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.05em", paddingLeft: "4px", marginBottom: "4px" }}>
              Learning Menu
            </div>
            
            {/* --- Battle Option Tab Trigger --- */}
            
            
            {currentUser && (
              <button 
                onClick={() => {
                  navigate("/profile");
                  setShowHistoryMobile(false);
                }} 
                style={{
                  ...navButtonStyle,
                  ...(showProfileAlert ? {
                    border: "1px solid #6366f1",
                    boxShadow: "0 0 0 3px rgba(99, 102, 241, 0.25)",
                    backgroundColor: "#eef2ff"
                  } : {})
                }}
              >
                <div style={navIconContainerStyle("#e0e7ff", "#4f46e5")}>
                  <span className="material-icons" style={{ fontSize: "18px" }}>manage_accounts</span>
                </div>
                <span style={navTextStyle}>Profile Edit</span>
                <span className="material-icons" style={navChevronStyle}>chevron_right</span>
              </button>
            )}
            
            {/* <button style={navButtonStyle}>
              <div style={navIconContainerStyle("#dbeafe", "#2563eb")}>
                <span className="material-icons" style={{ fontSize: "18px" }}>trending_up</span>
              </div>
              <span style={navTextStyle}>Learning Progress</span>
              <span className="material-icons" style={navChevronStyle}>chevron_right</span>
            </button> */}

            <button onClick={() => window.open("/challenge", "_blank")} style={navButtonStyle}>
              <div style={navIconContainerStyle("#ffedd5", "#ea580c")}>
                <span className="material-icons" style={{ fontSize: "18px" }}>emoji_events</span>
              </div>
              <span style={navTextStyle}>Challenges & Badges</span>
              <span className="material-icons" style={navChevronStyle}>chevron_right</span>
            </button>

            
            <button
              onClick={() => {
                navigate("/genius-test");
                setShowHistoryMobile(false);
              }}
              style={navButtonStyle}
            >
              <div style={navIconContainerStyle("#ede9fe", "#7c3aed")}>
                <span
                  className="material-icons"
                  style={{ fontSize: "18px" }}
                >
                  psychology
                </span>
              </div>

              <span style={navTextStyle}>
                Hidden Genius
              </span>

              <span
                className="material-icons"
                style={navChevronStyle}
              >
                chevron_right
              </span>
            </button>
            <button onClick={() => setShowFeedback(true)} style={navButtonStyle}>
              <div style={navIconContainerStyle("#f3f4f6", "#4b5563")}>
                <span className="material-icons" style={{ fontSize: "18px" }}>campaign</span>
              </div>
              <span style={navTextStyle}>Give Feedback</span>
              <span className="material-icons" style={navChevronStyle}>chevron_right</span>
            </button>


          </div>

          {/* --- 4. Chat History Section --- */}
          <div style={{ padding: "0 16px", flex: 1 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px", paddingLeft: "4px", marginTop: "8px" }}>
               <div style={{ fontSize: "0.75rem", fontWeight: "700", color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                 Chat History
               </div>
               
               <div style={{ position: "relative" }} ref={socialMenuRef}>
                  <button
                    onClick={() => setShowSocialMenu((v) => !v)}
                    style={{ background: "none", border: "none", color: "#64748b", display: "flex", alignItems: "center", gap: "4px", cursor: "pointer", fontSize: "0.8rem", fontWeight: "600" }}
                  >
                    Community <span className="material-icons" style={{ fontSize: "14px" }}>expand_more</span>
                  </button>
                  {showSocialMenu && (
                    <div style={{ position: "absolute", right: "0px", top: "48px", minWidth: "220px", background: "rgb(255, 255, 255)", borderRadius: "14px", boxShadow: "rgba(0, 0, 0, 0.18) 0px 12px 30px", padding: "6px 0px", zIndex: 9999 }}>
                      
                      <div onClick={() => window.open("https://fftech.in", "_blank")} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "11px 14px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "rgb(17, 17, 17)", background: "transparent", borderRadius: "8px", margin: "2px 6px" }}>
                        <span style={{ display: "flex", alignItems: "center", gap: "10px", flex: "1 1 0%" }}>
                          <span className="material-icons" style={{ fontSize: "18px", color: "rgb(68, 68, 68)" }}>language</span>FFT Website
                        </span>
                      </div>

                      <div onClick={() => window.open("https://instagram.com", "_blank")} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "11px 14px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "rgb(17, 17, 17)", background: "transparent", borderRadius: "8px", margin: "2px 6px" }}>
                        <span style={{ display: "flex", alignItems: "center", gap: "10px", flex: "1 1 0%" }}>
                          <span className="material-icons" style={{ fontSize: "18px", color: "rgb(68, 68, 68)" }}>photo_camera</span>Instagram
                        </span>
                      </div>

                      <div onClick={() => window.open("https://facebook.com", "_blank")} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "11px 14px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "rgb(17, 17, 17)", background: "transparent", borderRadius: "8px", margin: "2px 6px" }}>
                        <span style={{ display: "flex", alignItems: "center", gap: "10px", flex: "1 1 0%" }}>
                          <span className="material-icons" style={{ fontSize: "18px", color: "rgb(68, 68, 68)" }}>facebook</span>Facebook
                        </span>
                      </div>

                      <div onClick={() => window.open("https://linkedin.com", "_blank")} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "11px 14px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "rgb(17, 17, 17)", background: "transparent", borderRadius: "8px", margin: "2px 6px" }}>
                        <span style={{ display: "flex", alignItems: "center", gap: "10px", flex: "1 1 0%" }}>
                          <span className="material-icons" style={{ fontSize: "18px", color: "rgb(68, 68, 68)" }}>business</span>LinkedIn
                        </span>
                      </div>

                      <div onClick={() => window.open("https://twitter.com", "_blank")} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "11px 14px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "rgb(17, 17, 17)", background: "transparent", borderRadius: "8px", margin: "2px 6px" }}>
                        <span style={{ display: "flex", alignItems: "center", gap: "10px", flex: "1 1 0%" }}>
                          <span className="material-icons" style={{ fontSize: "18px", color: "rgb(68, 68, 68)" }}>close</span>X (Twitter)
                        </span>
                      </div>

                      <div onClick={() => window.open("https://whatsapp.com/channel/0029Vb7iGPaKQuJKrv220q03", "_blank")} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "11px 14px", cursor: "pointer", fontSize: "14px", fontWeight: "600", color: "rgb(17, 17, 17)", background: "rgb(232, 245, 233)", borderRadius: "8px", margin: "2px 6px" }}>
                        <span style={{ display: "flex", alignItems: "center", gap: "10px", flex: "1 1 0%" }}>
                          <svg width="18" height="18" viewBox="0 0 32 32" fill="#25D366" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.04 2C8.3 2 2 8.3 2 16.04c0 2.83.75 5.47 2.06 7.77L2 30l6.41-2.01a14 14 0 0 0 7.63 2.05h.01C23.7 30.04 30 23.74 30 16.04 30 8.3 23.7 2 16.04 2zm8.1 19.31c-.34.96-1.97 1.85-2.71 1.97-.71.11-1.61.16-2.6-.16-.6-.19-1.36-.44-2.34-.86-4.11-1.78-6.79-5.95-7-6.23-.21-.27-1.67-2.23-1.67-4.25 0-2.02 1.06-3.01 1.44-3.42.38-.41.83-.52 1.11-.52.28 0 .56 0 .8.01.26.01.6-.1.94.72.34.83 1.17 2.87 1.27 3.08.11.21.17.46.03.74-.14.27-.21.44-.41.68-.21.24-.44.53-.62.71-.21.21-.43.43-.19.85.24.41 1.06 1.75 2.27 2.83 1.56 1.39 2.88 1.82 3.29 2.03.41.21.65.18.89-.11.24-.28 1.02-1.19 1.29-1.6.27-.41.55-.34.92-.21.38.14 2.4 1.13 2.81 1.33.41.21.68.31.78.48.1.17.1.98-.24 1.94z"></path>
                          </svg>
                          WhatsApp
                        </span>
                        <span style={{ fontSize: "11px", background: "rgb(37, 211, 102)", color: "rgb(255, 255, 255)", padding: "2px 8px", borderRadius: "10px", whiteSpace: "nowrap" }}>JOIN</span>
                      </div>

                    </div>
                  )}
               </div>
            </div>

            {/* History List Rendering */}
            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              {sessions.length === 0 ? (
                <div style={{ textAlign: "center", padding: "20px", color: "#94a3b8", backgroundColor: "#ffffff", borderRadius: "12px", border: "1px dashed #cbd5e1" }}>
                  <span className="material-icons" style={{ fontSize: "32px", opacity: 0.5, marginBottom: "8px" }}>history_edu</span>
                  <p style={{ fontSize: "0.85rem", margin: 0 }}>No recent activity</p>
                </div>
              ) : (
                Object.entries(groupSessionsByDate(sessions)).map(([groupName, groupSessions]) => (
                  groupSessions.length > 0 && (
                    <div key={groupName}>
                      <div style={{ fontSize: "0.7rem", fontWeight: "600", color: "#94a3b8", marginBottom: "8px" }}>
                        {groupName}
                      </div>

                      <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                        {groupSessions.sort((a, b) => b.createdAt - a.createdAt).map((s) => {
                          const userQuestion = lastUserQuestionSafe(s) || "";
                          const subjectIcon = getSubjectIcon(userQuestion);
                          const isActive = s.id === currentSessionId;

                          return (
                            <div
                              key={s.id}
                              onClick={() => {
                                openSession(s.id);
                                setShowHistoryMobile(false);
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                backgroundColor: isActive ? "#fff7ed" : "#ffffff",
                                border: isActive ? "1px solid #fed7aa" : "1px solid transparent",
                                borderRadius: "10px",
                                padding: "10px",
                                cursor: "pointer",
                                transition: "all 0.15s ease",
                                boxShadow: "0 1px 2px rgba(0,0,0,0.02)"
                              }}
                            >
                              <div style={{ display: "flex", alignItems: "center", gap: "10px", flex: 1, minWidth: 0 }}>
                                <div style={{ color: isActive ? "#ea580c" : "#64748b", display: "flex" }}>
                                  <span className="material-icons" style={{ fontSize: "18px" }}>{subjectIcon}</span>
                                </div>
                                
                                <div style={{ flex: 1, minWidth: 0 }}>
                                  <div style={{ 
                                    fontSize: "0.85rem", 
                                    color: isActive ? "#9a3412" : "#334155", 
                                    fontWeight: isActive ? "600" : "500",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis"
                                  }}>
                                    {userQuestion || "New Discussion"}
                                  </div>
                                </div>
                              </div>

                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (confirmingDelete === s.id) {
                                    deleteSession(s.id);
                                    setConfirmingDelete(null);
                                  } else {
                                    setConfirmingDelete(s.id);
                                    setTimeout(() => setConfirmingDelete(null), 3000);
                                  }
                                }}
                                style={{
                                  background: confirmingDelete === s.id ? "#fee2e2" : "transparent",
                                  border: "none",
                                  borderRadius: "6px",
                                  padding: "6px",
                                  display: "flex",
                                  alignItems: "center",
                                  color: confirmingDelete === s.id ? "#dc2626" : "#cbd5e1",
                                  cursor: "pointer",
                                  transition: "all 0.15s"
                                }}
                              >
                                <span className="material-icons" style={{ fontSize: "16px" }}>
                                  {confirmingDelete === s.id ? "check" : "delete"}
                                </span>
                              </button>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )
                ))
              )}
            </div>
          </div>
        </div>

        {/* --- 5. Footer Section --- */}
        <div 
          className={`aa-left-footer ${leftFooterStyle && leftFooterStyle.left ? "fixed" : ""}`}
          style={
            leftFooterStyle && leftFooterStyle.left
              ? {
                  left: leftFooterStyle.left,
                  width: leftFooterStyle.width,
                  bottom: leftFooterStyle.bottom,
                  zIndex: leftFooterStyle.zIndex,
                }
              : { padding: "20px 20px 20px 20px", marginTop: "auto" }
          }
        >
          <div 
            className="aa-left-footer-inner" 
            style={{ 
              display: "flex", 
              justifyContent: "space-between", 
              alignItems: "center", 
              gap: "12px",
              borderTop: "1px solid #e2e8f0", 
              paddingTop: "12px",
              flexWrap: "wrap" // Ensures responsiveness on smaller screens
            }}
          >
            <a
              href="https://play.google.com/store/apps/details?id=com.agnitutorai.mobile"
              target="_blank"
              rel="noopener noreferrer"
              className="playstore-btn"
              style={{ display: "inline-flex", alignItems: "center" }}
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Google Play"
                style={{ height: "40px", width: "auto", display: "block" }}
              />
            </a>
                      
            <div className="muted small" style={{ fontSize: "0.8rem", color: "#64748b" }}>
              Crafted By{" "}
              <a 
                href="https://fftech.in" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ color: "#f97316", fontWeight: "600", textDecoration: "none" }}
              >
                FFT
              </a>
            </div>  

            <div className="muted small" style={{ fontSize: "0.8rem", color: "#64748b", textAlign: "center", width: "100%" }}>
                <a 
                  href="https://fftech.in/agni-tutor-privacy-policy.php" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ color: "#f97316", fontWeight: "600", textDecoration: "none" }}
                >
                  Privacy Policy
                </a>
              </div>
          </div>
        </div>

      </div>
    </div>
  );
}

// --- Helper Styles for Navigation Buttons ---
const navButtonStyle = {
  display: "flex",
  alignItems: "center",
  width: "100%",
  padding: "10px 12px",
  backgroundColor: "#ffffff",
  border: "1px solid #e2e8f0",
  borderRadius: "12px",
  cursor: "pointer",
  transition: "all 0.2s ease",
  boxShadow: "0 1px 3px rgba(0,0,0,0.02)",
};

const navIconContainerStyle = (bg, color) => ({
  width: "32px",
  height: "32px",
  borderRadius: "8px",
  backgroundColor: bg,
  color: color,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginRight: "12px"
});

const navTextStyle = {
  flex: 1,
  textAlign: "left",
  fontSize: "0.9rem",
  fontWeight: "600",
  color: "#334155"
};

const navChevronStyle = {
  fontSize: "20px",
  color: "#cbd5e1"
};